// command-adapter-types-and-tool-fragments.ts
//
// Adapter definition types + the shared tool-list fragments every table row
// expands from ("EDIT_FAMILY" = the four Edit-family tool names,
// "READ_ONLY_TOOLS" = Read/Grep/Glob repeated on every row). A LEAF module —
// imports nothing — so command-adapter-table.ts and the row files can both
// import it without an ESM cycle (a cycle would leave these top-level consts
// uninitialised when a row file evaluates). Split out of
// command-adapter-table.ts, plan 20260924-0205 (200-line budget).
export type CommandAdapterKind =
  | "survey"
  | "plan"
  | "testcase"
  | "implement"
  | "test"
  | "fix"
  | "review"
  | "decision"
  | "revert"
  | "deploy";

export type CommandAdapterExecutor = "claude" | "controller";

export interface CommandAdapterDefinition {
  id: string;
  kind: CommandAdapterKind;
  executor: CommandAdapterExecutor;
  entryPoint: string;
  allowedTools: string[];
  // "Subagent policy" column of command-adapters.md: count of named
  // internal subagents this adapter's prompt is allowed to spawn (0 for
  // controller-executed revert/deploy, which spawn no Claude session at
  // all). Registry validates this against config's max_internal_subagents
  // at resolve time (non-functional requirement: "subagent ≤
  // max_internal_subagents") — never hardcode a number above the config
  // limit into a session.
  maxInternalSubagents: number;
}

export const EDIT_FAMILY = ["Edit", "Write", "MultiEdit", "NotebookEdit"] as const;
export const READ_ONLY_TOOLS = ["Read", "Grep", "Glob"];
export const EDIT_FAMILY_TOOLS = [...EDIT_FAMILY];

/**
 * N-08 (dogfood worker thật 2026-09-15): a staging-only write grant must be
 * spelled for EVERY Edit-family tool. Probed on claude 2.1.153: an
 * `--allowedTools "Write(out/**)"` rule leaves Write DENIED ("don't ask
 * mode"), while `Edit(out/**)` lets Write through — Claude Code grants the
 * family through the `Edit(pattern)` rule only. The pack's WHW hook
 * (`tool_rule_grants_path`) instead looks for a rule spelled with the CALLED
 * tool's own name. Real missions ME-2026-11ce3c / ME-2026-f20511: every
 * plan-v1 and survey-v1 staging Write was denied by the permission layer, so
 * the lone `Write(...)` rule had never worked. Same B29 shape, scoped.
 */
export const STAGING_WRITE_TOOLS: readonly string[] = EDIT_FAMILY.map(
  (name) => `${name}(.avatar/attempt-output/**)`,
);
